import React, { useEffect, useState } from 'react'
import { Button, Drawer, Divider } from 'antd'
import { MenuUnfoldOutlined } from '@ant-design/icons'
import './styles.scss'

const items = [
    {
        key: '1',
        label: 'Our Story',
        link: '#our-story',
    },
    {
        key: '2',
        label: 'Why Choose Visit Pearl',
        link: '#why-choose',
    },
    {
        key: '3',
        label: 'Custom Events',
        link: '#custom-events',
    },
    {
        key: '4',
        label: 'Our Commitment',
        link: '#our-commitment',
    }
]

const AboutUs = () => {
    const [isNavDrawerOpen, setIsNavDraweOpen] = useState(false);

    useEffect(() => {
        const url = window.location.href;
        const section = url.split('#')[1];
        if (section) {
            scrollToSection(`#${section}`);
        }
    }, []);

    const scrollToSection = (id) => {
        const section = document.querySelector(id);
        if (section) {
            const offset = window.innerWidth > 768 ? 100 : 60;
            const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: sectionPosition,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div className='about-us section_main' style={{ marginBottom: '60px' }}>
            <div className='top_padding_container'>
                <h1 className='header_1'>
                    About Us
                </h1>
            </div>

            <div className='mobile_nav'>
                <Button onClick={() => setIsNavDraweOpen(true)}><MenuUnfoldOutlined /> Open Menu</Button>
            </div>

            <div className='body'>
                <div className='terms__nav'>
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className='terms__nav__container__items__item'
                            onClick={() => scrollToSection(item.link)}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>

                <div className='terms'>
                    <p className='paragraph' id='our-story'>
                        At Visit Pearl, we're passionate about connecting international travelers with the wonders of Sri Lanka. Our mission is to bring travelers closer to Sri Lanka's culture, history, and breathtaking landscapes while supporting local communities and businesses along the way. With our team of experts based both in Australia and Sri Lanka, we deliver thoughtfully curated journeys that allow you to experience the true essence of the island.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='why-choose'>
                        Why Choose Visit Pearl?
                    </h2>
                    <h3 className='header_4'>
                        Custom & Set Itineraries Tailored for Every Traveler
                    </h3>
                    <p className='paragraph'>
                        Our itineraries are designed with flexibility and variety in mind. Whether you're traveling solo, as a couple, family, or as groups we offer a range of set tours to suit different interests and preferences. For those seeking a more personalized experience, our custom tours allow you to create an itinerary tailored just for you. From tropical beach getaways to cultural and wildlife explorations, every itinerary is designed to provide an immersive experience that reflects the diversity of Sri Lanka.
                    </p>
                    <h3 className='header_4'>
                        All-Inclusive, Worry-Free Experiences
                    </h3>
                    <p className='paragraph'>
                        At Visit Pearl, we believe in providing seamless travel experiences. Each of our tours is all-inclusive, covering accommodations, meals, transportation, guided tours, and entrance fees, so you can relax and enjoy every moment of your trip. With us, there's no need to worry about logistics—we handle everything, from the moment you arrive to the day you return home.
                    </p>
                    <h3 className='header_4'>
                        Authentic Experiences that Support Local Communities
                    </h3>
                    <p className='paragraph'>
                        We're committed to sustainable and responsible travel. By partnering with local hotels, restaurants, guides, and artisans, we ensure that our tours benefit the communities you visit. Our approach helps to sustain Sri Lankan businesses, promote authentic cultural exchanges, and support environmental initiatives across the island. With Visit Pearl, your travel experience contributes positively to Sri Lanka's economy and culture.
                    </p>
                    <h3 className='header_4'>
                        Unforgettable Memories with Dedicated Local Guides
                    </h3>
                    <p className='paragraph'>
                        Our local guides are passionate about sharing their knowledge and love for Sri Lanka. They go beyond simply showing you the sights; they introduce you to the hidden stories, folklore, and unique insights that make each location special. Our guides are trained and licensed by the Sri Lanka Tourism Development Authority (SLTDA), ensuring both safety and authenticity in every part of your journey.
                    </p>
                    <h3 className='header_4'>
                        Flexible Travel for Individuals, Couples, Families & Groups
                    </h3>
                    <p className='paragraph'>
                        We know that every traveler has unique needs. Whether it's a family-friendly adventure, a romantic getaway, or a solo exploration, we provide options that cater to different types of travelers. Our family packages offer a mix of educational and fun activities suitable for all ages, while our couple's itineraries often include private tours, luxury accommodations, and curated romantic experiences. If you are mix of both, or a group of friends, we will help you build memories of a lifetime through curated adventures and experiences.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='custom-events'>
                        Custom Events
                    </h2>
                    <p className='paragraph'>
                        From weddings and birthdays to private parties and corporate retreats, we offer tailored event planning services across Sri Lanka. Whether it's an intimate beach ceremony, a milestone celebration, or a business event in a scenic location, we take care of every detail—venue, catering, décor, logistics, and guest arrangements.
                    </p>
                    <p className='paragraph'>
                        With teams based in both Australia and Sri Lanka, we work with trusted local partners to ensure your event is seamless, memorable, and infused with authentic Sri Lankan charm.
                    </p>
                    <p className='paragraph'>
                        We curate plans and organise your experiences for:
                    </p>
                    <ul>
                        <li>Weddings & engagements</li>
                        <li>Private celebrations (birthdays, anniversaries, parties)</li>
                        <li>Corporate events & retreats</li>
                        <li>Wellness gatherings and group experiences</li>
                    </ul>
                    <p className='paragraph'>
                        As well as any idea you wish to develop into a real experience.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='our-commitment'>
                        Our Commitment to Excellence and Trust
                    </h2>
                    <p className='paragraph'>
                        Visit Pearl is proudly registered with the Sri Lanka Tourism Development Authority (SLTDA), a mark of our commitment to quality and safety. This accreditation means we adhere to high standards in all our services, from tour planning to on-the-ground experiences. When you travel with us, you can trust that your journey will be both inspiring and professionally managed.
                    </p>
                    <p className='paragraph'>
                        Embark on Your Sri Lankan Adventure with Visit Pearl
                    </p>
                    <p className='paragraph'>
                        Join us in exploring Sri Lanka, a land of beauty, culture, and adventure. Whether you're stepping into ancient temples, tasting authentic cuisine, spotting a leopard, or relaxing on pristine beaches, we're here to make sure every detail is perfectly planned and expertly executed. The local customs held from an ancient age are focused on providing visitors of the land with the "best of" resources before oneself. Start your journey with Visit Pearl and discover the treasures of Sri Lanka, one unforgettable experience at a time.
                    </p>
                </div>
            </div>

            <Drawer
                title="About Us Sections"
                className='home__nav__drawer'
                rootClassName='home__nav__drawer_body'
                placement='bottom'
                closable={false}
                open={isNavDrawerOpen}
                onClose={() => setIsNavDraweOpen(false)}
                height='70vh'
                headerStyle={{ display: 'none' }}
            >
                <div className='terms__nav_drawe'>
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className='terms__nav__container__items__item_drawer'
                            onClick={() => {
                                scrollToSection(item.link)
                                setIsNavDraweOpen(false)
                            }}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            </Drawer>
        </div>
    )
}

export default AboutUs